import React, { useState } from 'react'
import {Table, Button, Row, Col, Alert, FormControl, InputGroup} from 'react-bootstrap'
import './CareUnitList.css'
import SaveCareUnitDialog from './SaveCareUnitDialog';
import {Container} from "react-bootstrap";
import {BsExclamationCircleFill, BsPencilSquare, BsPlus, BsSearch} from "react-icons/bs";

const CareUnitList = ({
    careUnits,
    createDialogOpen,
    updateDialogOpen,
    careUnitForm,
    saveCareUnitError,
    loggedInCareUnit,
    loggedInUserRole,
    addCareUnitClicked,
    updateCareUnitClicked,
    closeDialogClicked,
    deleteCareUnit,
    createCareUnit,
    updateCareUnit,
    errorMessage,
    isLoading,
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredCareUnits = (careUnits || []).filter(cu => {
        if (!searchTerm) return true;
        return cu.name?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
    <div className="CareUnitList">
        <Container id={"careUnitMainGrid"} className="">
            {errorMessage &&
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Alert variant={"danger"}>
                            <b><BsExclamationCircleFill/> {errorMessage}</b>
                        </Alert>
                    </Col>
                </Row>
            }
            <Row>
                <Col xs={12}>
                    <h1>Vårdenheter</h1>
                </Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Col xs={12} sm={6} md={4}>
                    <InputGroup>
                        <InputGroup.Text className="SaveCareUnitDialog-input-icon"><BsSearch /></InputGroup.Text>
                        <FormControl
                            type="text"
                            placeholder="Sök på namn..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                </Col>
                <Col xs={12} sm={6} md={8} className="d-flex align-items-end justify-content-end">
                    <Button className="add-button mb-0" onClick={() => addCareUnitClicked()}><BsPlus/> Lägg till</Button>
                </Col>
            </Row>
        </Container>

        {(updateDialogOpen && (
            <div>
                <SaveCareUnitDialog
                    saveErrorMessage={saveCareUnitError}
                    onCancelClicked={closeDialogClicked}
                    onUpdateClicked={updateCareUnit}
                    onDeleteClicked={deleteCareUnit}
                    careUnitForm={careUnitForm}
                    loggedInUserRole={loggedInUserRole}
                    isLoading={isLoading}
                />
            </div>
        )) || (createDialogOpen && (
            <SaveCareUnitDialog
                saveErrorMessage={saveCareUnitError}
                careUnitForm={{}}
                onCancelClicked={closeDialogClicked}
                onSaveClicked={createCareUnit}
                loggedInUserRole={loggedInUserRole}
                isLoading={isLoading}
            />
        ))}

        <Table size="sm" hover responsive>
            <thead>
            <tr>
                <th>#</th>
                <th>Namn</th>
                <th>Email</th>
                <th>Kontaktperson</th>
                <th>Telefon kontakt</th>
                <th>Gatuadress</th>
                <th>Postnummer</th>
                <th>Stad</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {
                filteredCareUnits.map((org, index) =>
                    <tr key={index}>
                        <td>{index+1}</td>
                        <td>{org.name}</td>
                        <td>{org.organizationEmail}</td>
                        <td>{org.contactName}</td>
                        <td>{org.contactPhoneNumber}</td>
                        <td>{org.streetAddress}</td>
                        <td>{org.zipCode}</td>
                        <td>{org.city}</td>
                        <td>
                            <div className={"float-end table-buttons d-flex align-items-center"}>
                                <Button onClick={() => updateCareUnitClicked(org)} disabled={org.name===loggedInCareUnit}><BsPencilSquare/><span> Uppdatera</span></Button>
                            </div>
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>
    </div>)}
export default CareUnitList;